import styled from 'styled-components';

export const StatsPageMessage = styled.p`
  white-space: pre-line;
`;
